const PRODUCT_TYPES = {
    SIMPLE: 'simple',
    CONFIGURABLE: 'configurable',
    VIRTUAL: 'virtual',
};

const STOCK_STATUSES = {
    IN_STOCK: 'IN_STOCK',
    OUT_OF_STOCK: 'OUT_OF_STOCK',
};

const VIP = 'vip';

const CREATE_ACCOUNT = 'account';

const COOKIE_CONSENT = 'cookie_consent';

const TEST_VERSION = {
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
};

export {
    PRODUCT_TYPES,
    STOCK_STATUSES,
    VIP,
    CREATE_ACCOUNT,
    COOKIE_CONSENT,
    TEST_VERSION,
};

